// Tablet Grid/List Switcher
(function() {
  function init() {
    var container = document.querySelector('.collection__container');
    if (!container) return;

    document.querySelectorAll('.collection-grid__item').forEach(function(icon) {
      icon.addEventListener('click', function() {
        var gridT = this.getAttribute('data-grid-t');
        
        if (gridT === 'page-grid-st-1') {
          // LIST VIEW
          container.classList.remove('page-grid-st-2', 'page-grid-st-3', 'page-grid-st-4');
          container.classList.add('page-grid-st-1');
          container.style.setProperty('grid-template-columns', '1fr', 'important');
        } else if (gridT) {
          // GRID VIEW - always use page-grid-st-3 (matches desktop 3rd icon)
          container.classList.remove('page-grid-st-1', 'page-grid-st-2', 'page-grid-st-4');
          container.classList.add('page-grid-st-3');
          container.style.removeProperty('grid-template-columns');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  setTimeout(init, 300);
})();